import logger from '@/app/logger';
import axios from 'axios';
import type { NewsItemsQuery } from '@/server/graphql/__generated__/graphql';

export type NewsItemType = NonNullable<NewsItemsQuery['News']>;
export type NewsItemItemsType = NonNullable<NewsItemType['items']>;

export const newsItemQuery_Client = async (routeSegment: string) => {
  const url = '/api/cms/news' + (routeSegment ? `/${routeSegment}` : '');
  logger.info(`Fetching news items data... url: ${url}`);
  return axios
    .get(url)
    .then((res) => {
      if (!res?.data) {
        return Promise.reject(new Error('No data returned from news item response. RouteSegment: ' + routeSegment));
      }
      logger.info(`Got news item response. RouteSegment: ${routeSegment}`);
      const data = res.data;
      if (!data) {
        return Promise.reject(new Error('No news item data for the routeSegment: ' + routeSegment));
      }
      return data as NewsItemItemsType;
    })
    .catch((err: unknown) => {
      logger.info('Got error:', err);
      return Promise.reject(err);
    });
};
